module.exports = __webpack_public_path__ + "static/media/bottom-fade.45dfc30e.png";